import { ModeAndThemeOption } from "@/pages/user-settings/mode-theme";
import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import "./styles/PopupDownloadTemplate.css";

const PopupDownloadTemplate = ({ open, children,onClose,selectTemplate,setTemplateColor,templateColor,onClick , isLoadingDownload }) => {
  return (
    <GenericPopup
      open={open}
      opacity
      className="artwork-options__download-template-container w-[25em]  pb-4">
      <div className="artwork-options__download-template_header">
        <p className="artwork-options__download-template_header-text">
            Generate template
        </p>
        <p className="artwork-options__download-template_header-step-text">
          <span className="artwork-options__download-template_header-step-text-span">
              3.{" "}
          </span>
            Choose a color theme for this template
        </p>
        <XIcon
          className="artwork-options__download-template_header-Xicon"
          onClick={() => {
            onClose();
          }}
        />
      </div>
      <div className="artwork-options__download-template-templates-select-color">
        <ModeAndThemeOption
          className="starry artwork-download-template-color"
          isActive={templateColor === "starry_moon"}
          onClick={() => {
            setTemplateColor("starry_moon");
          }}
        />
        <ModeAndThemeOption
          className="dancing artwork-download-template-color"
          isActive={templateColor === "dancing-on-the-grass"}
          onClick={() => {
            setTemplateColor("dancing-on-the-grass");
          }}
        />
        <ModeAndThemeOption
          className="fountain artwork-download-template-color"
          isActive={templateColor === "fountain-of-delights"}
          onClick={() => {
            setTemplateColor("fountain-of-delights");
          }}
        />
        <ModeAndThemeOption
          className="water artwork-download-template-color"
          isActive={templateColor === "swinging-dress"}
          onClick={() => {
            setTemplateColor("swinging-dress");
          }}
        />
        <ModeAndThemeOption
          className="violet artwork-download-template-color"
          isActive={templateColor === "water-lily-pond"}
          onClick={() => {
            setTemplateColor("water-lily-pond");
          }}
        />
      </div>
      <div
        className={`overflow flex h-10 justify-center ${
          selectTemplate === "story"
            ? "artwork-options__download-template-templates__story"
            : "artwork-options__download-template-templates__post"
        }`}
      >
        {children}
      </div>
      <ContinueButton loading={isLoadingDownload}
        className={`artwork-options__download-template-templates-continue-button active ${
          selectTemplate === "story"
            ? "artwork-options__download-template-download__button-story"
            : "artwork-options__download-template-download__button-post"
        }`}
        onClick={onClick}
      >
          Download
      </ContinueButton>
    </GenericPopup>
  );
};

export default PopupDownloadTemplate;